import { ArtistCard } from './ArtistCard';
import './GenrePanel.css';

interface KeyArtistLinks {
  bandcamp?: string;
  spotify?: string;
  youtube?: string;
  youtubeVideoId?: string;
}

interface KeyArtist {
  name: string;
  track: string;
  links?: KeyArtistLinks;
}

interface GenrePanelProps {
  description: string;
  keyArtists: KeyArtist[];
  getPlatformLinks?: (name: string) => {
    bandcamp: string;
    spotify: string;
    apple: string;
    tidal: string;
    amazon: string;
  };
}

// Default search link generator
function defaultGetPlatformLinks(artistName: string) {
  const encoded = encodeURIComponent(artistName);
  return {
    bandcamp: `https://bandcamp.com/search?q=${encoded}`,
    spotify: `https://open.spotify.com/search/${encoded}`,
    apple: `https://music.apple.com/search?term=${encoded}`,
    tidal: `https://tidal.com/search?q=${encoded}`,
    amazon: `https://music.amazon.com/search/${encoded}`,
  };
}

// Convert KeyArtist to ArtistCard-compatible format
function keyArtistToCardArtist(keyArtist: KeyArtist) {
  return {
    name: keyArtist.name,
    genres: [], // Will be enriched via ArtistDataContext
    era: null,
    location: null,
    matchReason: '', // No match reason for key artists
    confidence: 1,
    tracks: [keyArtist.track],
    links: keyArtist.links,
    youtubeVideoId: keyArtist.links?.youtubeVideoId,
  };
}

export function GenrePanel({
  description,
  keyArtists,
  getPlatformLinks = defaultGetPlatformLinks,
}: GenrePanelProps) {
  return (
    <div className="genre-panel">
      <p className="genre-panel-description">{description}</p>

      {keyArtists.length > 0 && (
        <div className="genre-panel-artists">
          {keyArtists.map((keyArtist) => (
            <ArtistCard
              key={keyArtist.name}
              artist={keyArtistToCardArtist(keyArtist)}
              getPlatformLinks={getPlatformLinks}
            />
          ))}
        </div>
      )}
    </div>
  );
}
